import type { ComponentProps } from 'react';
import { cn } from '../../common/functions/cn';

export const Skeleton = ({ className, ...props }: ComponentProps<'div'>) => (
  <div data-slot="skeleton" className={cn('animate-pulse rounded-md bg-border', className)} {...props} />
);
